import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedPlanningTile } from "../redux/selector";
import { backlogActions } from "../redux/slice";
import { IPlanningViewsGroup, PlanningTileId, PlanningViewBy } from "../types";
import { getPlanningTileId } from "../helper";

const getGroupTicketIds = (group: IPlanningViewsGroup) => {
  if (group.ticketIds?.length) return group.ticketIds;
  return group.ticketTypes?.flatMap((item) => item.ticketIds ?? []) ?? [];
};

export function usePlanningTileFilter() {
  const dispatch = useDispatch();
  const selectedTile = useSelector(selectSelectedPlanningTile);

  const handleTileClick = useCallback(
    (tileId: PlanningTileId, ticketIds: string[] = []) => {
      if (selectedTile?.id === tileId) {
        dispatch(backlogActions.setSelectedPlanningTile(null));
        return;
      }

      dispatch(
        backlogActions.fetchPlanningFilterTickets({ tileId, ticketIds }),
      );
    },
    [dispatch, selectedTile?.id],
  );

  const isTileActive = useCallback(
    (tileId: PlanningTileId) => selectedTile?.id === tileId,
    [selectedTile?.id],
  );

  const getTileClickHandler = useCallback(
    (viewBy: PlanningViewBy, group: IPlanningViewsGroup) => () =>
      handleTileClick(getPlanningTileId(viewBy, group), getGroupTicketIds(group)),
    [handleTileClick],
  );

  const getTileActiveState = useCallback(
    (viewBy: PlanningViewBy, group: IPlanningViewsGroup) =>
      isTileActive(getPlanningTileId(viewBy, group)),
    [isTileActive],
  );

  return {
    selectedTile,
    handleTileClick,
    isTileActive,
    getTileClickHandler,
    getTileActiveState,
  };
}
